import type React from 'react';
import { useState } from 'react';
import { cn } from 'shared/src/utils';

export interface TrainingSectionProps {
  id?: string;
  title: string;
  description?: string;
  icon: React.ComponentType<{ className?: string }>;
  iconColor: string;
  bgColor: string;
  borderColor: string;
  count: number;
  children: React.ReactNode;
  collapsible?: boolean;
  defaultCollapsed?: boolean;
  emptyMessage?: string;
}

export default function TrainingSection({
  id,
  title,
  description,
  icon: Icon,
  iconColor,
  bgColor,
  borderColor,
  count,
  children,
  collapsible = false,
  defaultCollapsed = false,
  emptyMessage,
}: TrainingSectionProps) {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  return (
    <section id={id} className={cn('scroll-mt-4 rounded-lg border p-4', bgColor, borderColor)}>
      <button
        type="button"
        className={cn('flex items-center gap-2 w-full text-left', collapsible ? 'cursor-pointer' : 'cursor-default')}
        onClick={() => collapsible && setIsCollapsed(!isCollapsed)}
        disabled={!collapsible}
      >
        <Icon className={cn('h-5 w-5', iconColor)} />
        <h3 className="text-base font-semibold text-gray-900 flex-1">
          {title} ({count})
        </h3>
        {collapsible && <span className={cn('text-gray-500 transition-transform', isCollapsed ? '' : 'rotate-180')}>▼</span>}
      </button>
      {description && !isCollapsed ? <p className="mt-1 text-sm text-gray-600">{description}</p> : null}
      {!isCollapsed && <div className="space-y-2 mt-3">{count === 0 && emptyMessage ? <p className="text-sm text-gray-600">{emptyMessage}</p> : children}</div>}
    </section>
  );
}
